module.exports = __webpack_public_path__ + "img/ewm.75fc4335.jpg";